import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from '../../../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import { leaveColor } from '../../helpers/color'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import metrolendarHelper from '../../helpers/date'

export const DataInput = (props) => {
  const { task, project, holidaysApproval, leaveRequests, compensateRequests } = props
  const weekdates = get(props, 'weekdates')
  const timesheetRequest = get(props, 'timesheetRequest')
  const selectedDate = get(props, 'selectedDate')
  const month = get(timesheetRequest, 'timesheetRequest.timesheet_snapshot.month')
  const { handleClickCell } = props
  const week = metrolendarHelper.getTableWeekDates(moment(month), 'month')
  const date = find(weekdates, (time) => {
    const d1 = moment(selectedDate).format('YYYY-MM-DD')
    const d2 = moment(time).format('YYYY-MM-DD')
    if (d1 === d2) return moment(date).format('YYYY-MM-DD')
    return null
  })
  const dayweek = (selectedDate.isSame(moment(), 'day') && selectedDate.isSame(moment(), 'month')) ? week : weekdates

  return (
    <Column>
      { dayweek.map((time) => {
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidaysApproval, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)

        let day = ''
        let dataType
        let data

        const dateTarget = find(get(task, 'times', []), (task2) => {
          const d1 = moment(task2.date).format('YYYY-MM-DD')
          const d2 = moment(time).format('YYYY-MM-DD')
          if (d1 === d2) return moment(dateTarget).format('YYYY-MM-DD')
          return null
        })

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Hour>{ (dateTarget === undefined) ? '' : dateTarget.hours }</Hour>

          </Cell>
        )
      }) }
    </Column>
  )
}

export const EmptyInput = (props) => {
  const { holidaysApproval, month, project, leaveRequests, compensateRequests, task } = props
  const { handleClickCell } = props

  return (
    <Column>
      <Total />
      { get(task, 'times', timesheetHelper.getTableDates(moment(month))).map(time => {
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidaysApproval, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)


        let day = ''
        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Date />
          </Cell>
        )
      }) }
    </Column>
  )
}

DataInput.propTypes = {
  holidaysApproval: PropTypes.array,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  task: PropTypes.object,
  project: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
}
DataInput.defaultProps = {
  holidaysApproval: [],
  leaveRequests: [],
  compensateRequests: [],
  task: {},
  project: {},
}
EmptyInput.propTypes = {
  holidaysApproval: PropTypes.array,
  task: PropTypes.object,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  project: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
  month: PropTypes.any,
}
EmptyInput.defaultProps = {
  holidaysApproval: [],
  task: {},
  leaveRequests: [],
  compensateRequests: [],
  project: {},
  month: moment(),
}

const Column = styled.div`
  height: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
`
const Cell = styled.div`
  font-family: 'Gotham' !important;
  font-size: 10px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${props => { return props.canClick ? 'pointer' : 'default' }};
  @media (max-width: 575.98px) {
  border: solid #d2d2d2d2;
  border-width: 0.5px 0.5px 1px 0.5px;
  }
  @media (max-width: 767.98px) {
    border: solid #d2d2d2d2;
    border-width: 0.5px 0.5px 1px 0.5px;
  }
  background-color: ${(props) => { return leaveColor(props.day) }};
`
const Total = styled.span`
  width: 40px;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Date = styled.div`
  font-family: 'Gotham-Bold' !important;
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return 'black'
  }};
`
const Hour = styled.span`
  width: 40px;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/input-col-mobile.js